import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=7839989f&scoped=true"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js"
import style0 from "./ArticleTemplate.vue?vue&type=style&index=0&id=7839989f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839989f",
  null
  
)

export default component.exports